import { useState } from 'react';
import { faqs } from '@/mocks/content';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="FAQ"
          title="常见问题"
          desc="关于本站内容、更新节奏、院线同步与筛选功能的常见疑问，整理如下。点击问题即可展开或收起。"
          align="center"
        />

        <div className="mt-8 max-w-3xl mx-auto space-y-3">
          {faqs.map((faq) => {
            const open = openId === faq.id;
            return (
              <div key={faq.id} className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                <h3>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenId(open ? null : faq.id)}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-950">{faq.question}</span>
                    <span
                      className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                        open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'} />
                    </span>
                  </button>
                </h3>
                <div className={`collapsible-body ${open ? 'is-open' : ''}`}>
                  <p className="px-4 md:px-6 pb-4 md:pb-5 text-xs md:text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}